import axios from 'axios';

export default {
	methods: {
		/**
		 * Allows getting config data from the backend. For security reasons only data that is already public is available
		 *
		 * @param {string} name of the data we want to get
		 * @returns {Promise} The data from our config
		 */
		stget (name) {
			return axios.get(`/api/v0/configurations?name=${name}`)
				.then(({
					data
				}) => {
					return data;
				});
		},
	}
};
